<button
  type="button"
  class="chat-fab"
  [attr.aria-label]="label"
  [disabled]="isInteractionBlocked"
  (click)="!isInteractionBlocked && clicked.emit()"
>
  <span class="chat-fab__icon-well">
    <img src="assets/icons/rocket-assist-chat.svg" width="32" height="32" aria-hidden="true" alt="" class="chat-fab__icon">
  </span>
  @if (showLabel) {
    <span class="chat-fab__label">{{ label }}</span>
  }
</button>
